import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';
import Unit from '../Modular/Unit';

interface DropDownItemProps {
  id?: number;
  route: string;
  onClick: () => void;
  itemNo?: string;
}

const DropDownItem: React.FC<DropDownItemProps> = ({
  route,
  onClick,
  id,
  itemNo,
}) => {
  const link = route === 'Home' ? '/' : `/${route.toLowerCase()}`;
  const variant = route === 'Home' ? 'primary' : 'outline';
  const gridArea = id?.toString();

  return (
    <Unit gridArea={gridArea}>
      <Link to={link}>
        <Button variant={variant} onClick={onClick} intent="dropdown">
          {route}
        </Button>
      </Link>
    </Unit>
  );
};

export default DropDownItem;
